(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("TerrainTypeDialogController", TerrainTypeDialogController);

    TerrainTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "TerrainType",
        "User",
        "TerrainTypeSearch",
        "AllCustomTerrainTypeAttribute",
    ];


    function TerrainTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        TerrainType,
        User,
        TerrainTypeSearch,
        AllCustomTerrainTypeAttribute
    ) {
        var vm = this;
        //terraintype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.terrainType = entity;
        vm.terrainTypeImageName = terrainTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customTerrainTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");



        vm.checkNumber;





        function terrainTypeImageName(image) {
            vm.terrainType.image = image;
        }


        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomTerrainTypeAttribute.getAll(function (response) {
                vm.customTerrainTypeAttributes = response;
                console.log(vm.customTerrainTypeAttributes)
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customTerrainTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, defaultValue: "" }];

        if (
            vm.terrainType.terrainTypeAttribute != null &&
            vm.terrainType.terrainTypeAttribute.length != 0
        ) {
            vm.items = vm.terrainType.terrainTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.terrainCategory == null) {
                value.terrainCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.terrainType.id !== null) {
                vm.terrainType.terrainTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.terrainType.terrainTypeAttribute.push({
                        terrainCategory: vm.items[i].terrainCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        defaultValue: vm.items[i].defaultValue,
                        terrainTypeAttribOrder: vm.items[i].terrainTypeAttribOrder
                    });
                }
                TerrainType.update(vm.terrainType, onSaveSuccess, onSaveError);
            } else {
                vm.terrainType.terrainTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.terrainType.terrainTypeAttribute.push({
                        terrainCategory: vm.items[i].terrainCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        defaultValue: vm.items[i].defaultValue,
                        terrainTypeAttribOrder: vm.items[i].terrainTypeAttribOrder
                    });
                }
                TerrainType.save(vm.terrainType, onSaveSuccess, onSaveError);
            }
        }

        $("#terrainTypeImage").change(function () {
            var filesSelected = document.getElementById("terrainTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.terrainType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:terrainTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("terrain-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {


            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index + 1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });

        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);


        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.colorcode = function (color) {
            vm.terrainType.colorcode = color;
        }


    }
})();
